var map = {
	"./chat.svg": 66308,
	"./rocket.svg": 49623,
	"./twinkle.svg": 11999,
	"assets/icons/chat.svg": 66308,
	"assets/icons/rocket.svg": 49623,
	"assets/icons/twinkle.svg": 11999,
	"src/assets/icons/chat.svg": 66308,
	"src/assets/icons/rocket.svg": 49623,
	"src/assets/icons/twinkle.svg": 11999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;